import { Grid, IconButton, Tooltip } from '@mui/material'
import { useCallback, useContext, useEffect, useState } from 'react'
import { MdAdd, MdArrowBack } from 'react-icons/md'
import { GlobalContext } from '../../../App'
import Programa from '../../../components/Programa/Programa'
import { metodoPrograma } from '../../../components/api'
import Edicao from './Edicao'
import PrimeTable from '../../../components/PrimeTable'

const ConvenioCRUD = () => {
  const { localAtendimento } = useContext(GlobalContext)

  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [dados, setDados] = useState(null)
  const [refresh, setRefresh] = useState(0)

  const exclui = useCallback((conveio) => {
    metodoPrograma('exclui', { idConvenio: conveio[0] }).then((res) => {
      if (res.status) {
        setRefresh((prev) => prev + 1)
      }
    })
  }, [])

  const voltar = useCallback(() => {
    setTela('lista')
    setDados(undefined)
  }, [])

  const handleClick = (linha) => {
    setDados(linha)
    setTela('opcoes')
  }

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Adicionar">
            <IconButton onClick={() => setTela('opcoes')}>
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tela])

  return (
    <Programa codigo="CtrlConvenio" ferramentas={ferramentas}>
      {tela === 'lista' ? (
        <Grid container spacing={2}>
          {localAtendimento !== undefined && localAtendimento !== null && (
            <Grid item xs={12}>
              <PrimeTable
                codigo="CtrlConvenio"
                action="lista"
                parametros={{ idLocalAtendimento: localAtendimento?.[0] }}
                rows={10}
                habSearch
                head={['Convênio', 'Data Exclusão']}
                line={(item) => [item[2], item[3]]}
                collumnsDateHour={[1]}
                onDelete={{ index: 1, action: exclui }}
                refresh={refresh}
                onRowSelect={handleClick}
              />
            </Grid>
          )}
        </Grid>
      ) : (
        <Edicao {...{ dados, voltar }} />
      )}
    </Programa>
  )
}

export default ConvenioCRUD
